module.exports = __webpack_public_path__ + "static/img/banner____.46d4d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner____.png
// module id = zGEz
// module chunks = 1